import React from 'react';
import { Waypoint } from 'react-waypoint';
import { ElementLoader } from 'ui';
import { Switch } from 'ui/common/switch/switch';
import { DateFormatters } from 'app/infrastructure/data/types';
import { AdministrationMessagesTranslation } from '../../constants';
import { UpdateHandler, DeleteHandler } from '../types';
import { AdministrationMessagesListState } from '../types-store';
import { MessagesListItems } from './messages-list-items';
import { NumberOfResults } from './number-of-results';
import { MessagesListSearch } from './messages-list-search';

import styles from './messages-list-renderer.scss';

interface MessagesListRendererProps {
  listState: AdministrationMessagesListState;
  canEdit: boolean;
  canDelete: boolean;
  updateMessage: UpdateHandler;
  deleteMessage: DeleteHandler;
  fetchMore: () => void;
  updateQuery: (query: string) => void;
  updateIncludeInactive: (includeInactive: boolean) => void;
  translation: AdministrationMessagesTranslation;
  formatters: DateFormatters;
}

export const MessagesListRenderer: React.FC<MessagesListRendererProps> = ({
  listState, canEdit, canDelete, updateMessage, deleteMessage, fetchMore, updateQuery, updateIncludeInactive, translation, formatters
}) => {

  const { messages, updatingMessages, query, includeInactive } = listState;

  return <>
    <div className={'row'}>
      <h1 className="col-12">{translation.manage_messages_title}</h1>
      <MessagesListSearch
        canEdit={canEdit}
        query={query}
        updateQuery={updateQuery}
        translation={translation} />
      <div className="row">
        <div className="col-4">
          <NumberOfResults
            listState={listState}
            translation={translation} />
        </div>
        <div className={`col-8 ${styles.selectSwitch}`}>
          {translation.show_inactive_messages}
          <Switch
            checked={includeInactive}
            onChange={updateIncludeInactive} />
        </div>
      </div>
    </div>
    {  messages && messages.length > 0
      ? <MessagesListItems
        messages={messages}
        canEdit={canEdit}
        canDelete={canDelete}
        includeInactive={includeInactive}
        updatingMessages={updatingMessages}
        updateMessage={updateMessage}
        deleteMessage={deleteMessage}
        translation={translation}
        formatters={formatters}
      />
      : null}
    <Waypoint key="wpMessageAdministration" onEnter={fetchMore} scrollableAncestor={window} bottomOffset="-10%" />
    {listState.fetching ? <ElementLoader /> : null}
  </>;
};
